import { ServMan } from "./ServMan.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  ServMan
};
//# sourceMappingURL=index.js.map
